var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.fullUrl}},[_vm._v(" react-iframe ")])
}
var staticRenderFns = []

export { render, staticRenderFns }